import axios from "axios";
import { url } from "../Config";

class GetData {
  GetOpinion = () => {
    // ,alert('1')
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/getOpinionsList`)
        .catch(function (error) {
          console.log(error);
        });

      return resp;
    };
    return res();
  };
  BusinessGridData = () => {
    // ,alert('1')
    const res = async () => {
      const resp = await axios
        .get("http://127.0.0.1:8000/api/businessmainGrid")
        .catch(function (error) {
          console.log(error);
        });

      return resp;
    };
    return res();
  };
  PacVisIndexData = () => {
    // ,alert('1')
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/pac-vis-index`)
        .catch(function (error) {
          console.log(error);
        });

      return resp;
    };
    return res();
  };


  OutstandingData = () => {
    // ,alert('1')
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/outstanding`)
        .catch(function (error) {
          console.log(error);
        });

      return resp;
    };
    return res();
  };

  Outstandinglist = () => {
    // ,alert('1')
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/outstandinglist`)
        .catch(function (error) {
          console.log(error);
        });

      return resp;
    };
    return res();
  };


  InProcess = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/in-process`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };
  UnFinished = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/un-finished`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    // console.log(res(), "this is my unfinished");
    return res();
  };
  InHandBook = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/in-hand-book`)
        .catch(function (error) {
          console.log(error);
        });
      // console.log(resp, 'inhandBook')
      return resp;
    };
    return res();
  };
  GoneBook = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/gone-book`)
        .catch(function (error) {
          console.log(error);
        });
      // console.log(resp, 'GoneBook')
      return resp;
    };
    return res();
  };
  Initial = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/initial`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  InMNA = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/mna`)
        .catch(function (error) {
          console.log(error);
        });
      // console.log(resp, 'mnaarray')
      return resp;
    };
    return res();
  };

  InCob = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/cob`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  InICU = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/icu`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  InRIP = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/rip`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  Withdraw = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/withdraw`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  Sector = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/sector`)
        .catch(function (error) {
          console.log(error);
        });

      return resp;
    };
    return res();
  };

  Methodology = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/methodology`)
        .catch(function (error) {
          console.log(error);
        });

      return resp;
    };
    return res();
  };

  Inst = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/inst`)
        .catch(function (error) {
          console.log(error);
        });
        
      return resp;
    };
    return res();
  };

  InstP = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/instp`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  AddressBook = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/address-book`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  PvtRatings = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/pvt-ratings`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  Policy = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/policy`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  OtherCRA = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/otherCRA`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  DeadlineRc = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/deadline-rc`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  DeadlineDissemination = () => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/deadline-dissemination`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  DeadlineIc = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/deadline-ic`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  DeadlineFc = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/deadline-fc`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  DoneRc = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/done-rc`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };
  
  DoneDissemination = () => {
    const res = async () => {
      const resp = await axios
        .get(
          `${url}/api/done-dissemination`
        )
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };
  DoneIc = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/done-ic`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };
  DoneFc = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/done-fc`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };
  OpinionDetailsApi = (OpinionId) => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/opinion/${OpinionId}`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };
  OpinionDetailsTblOneApi = (OpinionId) => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/opinion/details/${OpinionId}`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };
  GroupDetailsTable = (OpinionId) => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/opinion/GroupRelatedDetails/${OpinionId}`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };
  OpinionTitle = (client_id) => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/getTitle/${client_id}`)
        .catch(function (error) {
          console.log(error);
        });
        // console.log(resp,'respoinse')
      return resp;
    };
    return res();
  };
  ClientTitle = (client_id) => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/client_opinion_relations/${client_id}`)
        .catch(function (error) {
          console.log(error);
        });
        // console.log(resp,'respoinse')
      return resp;
    };
    return res();
  };
  TabsDetailsApi = (client_id) => {
    const res = async () => {
      const resp = await axios
      .get(`${url}/api/opinion/SectorStudy/${client_id}`)
      .catch(function (error) {
        console.log(error);
      });
      // console.log(resp,'respoinse')
      return resp;
    };
    return res();
  };
  getHistory = (client_id) => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/getOpinionHistory/${client_id}`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };

  getDD2 = () => {
    const res = async () => {
      const resp = await axios
        .get(`${url}/api/deadline-dissemination2`)
        .catch(function (error) {
          console.log(error);
        });
      return resp;
    };
    return res();
  };
}
export default new GetData();
